

export const DecompositionString = (text: string): string => {
    if (text == null || text == undefined)
        return "";
    return text.replace(/([a-z])([A-Z])/g, '$1 $2');
}